import type { GlossType } from '@/types/GlossType'
import { GrammaticalClass } from '@/enums/GrammaticalClass'

export const sortGlossesByGrammaticalClass = (glosses: GlossType[]): Record<string, GlossType[]> =>
  glosses.reduce((acc, gloss) => {
    // add the gloss to the array of glosses for its grammatical class
    acc[gloss.grammaticalClass.name] = [...(acc[gloss.grammaticalClass.name] || []), gloss]
    // return the accumulator for the next iteration
    return acc
  }, {
    // sets the order of the grammatical classes
    [GrammaticalClass.Verb]: [],
    [GrammaticalClass.Subject]: [],
    [GrammaticalClass.Adjective]: [],
    [GrammaticalClass.Adverb]: [],
    [GrammaticalClass.Preposition]: [],
    [GrammaticalClass.Expression]: [],
    [GrammaticalClass.Word]: [],
    [GrammaticalClass.Pronoun]: [],
    [GrammaticalClass.Conjunction]: [],
    [GrammaticalClass.Interrogative]: [],
    [GrammaticalClass.Determiner]: [],
    [GrammaticalClass.Subjunction]: [],
    [GrammaticalClass.French]: [],
    [GrammaticalClass.Norwegian]: []
  } as Record<string, GlossType[]>)

